module.exports = __webpack_public_path__ + "static/media/Previous.256536ec.svg";